﻿<template>
  <div class="w-full space-y-4">
    <!-- Controls -->
    <div class="flex flex-wrap items-center justify-between gap-6 ">
      <div class="flex flex-wrap items-center gap-4">
      <div class="w-full">
        <label for="sortKey" class="text-sm font-medium min-w-max block mb-1">Sort by</label>
      </div>
      <div class="flex items-center gap-2">
        <select
        id="sortKey"
        v-model="sortKey"
        class="select select-sm border-gray-300 rounded-md min-w-[160px]"
        >
        <option value="departure">Departure Date</option>
        <option value="booking">Booking Date</option>
        <option value="id">Booking ID</option>
        <option value="reference">Agent Ref</option>
        <option value="lead">Lead Passenger</option>
        <option value="consultant">Consultant</option>
        <option value="status">Status</option>
        <option value="trip">Trip Name</option>
        </select>

        <button
        type="button"
        class="btn btn-sm border-gray-300 rounded-md min-w-max"
        @click="sortAsc = !sortAsc"
        :aria-pressed="!sortAsc"
        :title="sortAsc ? 'Ascending' : 'Descending'"
        >
        <span v-if="sortAsc">Asc ▲</span>
        <span v-else>Desc ▼</span>
        </button>
      </div>
      </div>
    </div>

    <!-- Cards -->
    <div
      v-for="(b, index) in Sorted_Bookings"
      :key="Row_Key(b, index)"
      class="rounded-xl border border-form shadow-md bg-white"
    >
      <div class="p-5 space-y-4">
        <div class="flex items-start justify-between gap-3">
          <div class="min-w-0">
            <h3 class="text-base font-semibold leading-tight">
              {{ Trip_Name(b) }}
            </h3>
            <p class="text-sm text-gray-light mt-1">
              Lead: <span class="font-medium text-gray-default">{{ Lead_Passenger(b) }}</span>
            </p>
          </div>

            <span
            class="inline-block px-2 py-0.5 rounded-md border border-form text-xs font-medium  whitespace-nowrap"
            >
            {{ Booking_Status(b) || '—' }}
          </span>
        </div>

        <div class="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
          <div>
            <div class="text-xs text-gray-light">Departure</div>
            <div class="font-bold text-black">
              {{ Departure_Date_Display(b) || '—' }}
            </div>
          </div>

          <div>
            <div class="text-xs text-gray-light">Booking Date</div>
            <div class="font-bold text-black">
              {{ Booking_Date_Display(b) || '—' }}
            </div>
          </div>

          <div>
            <div class="text-xs text-gray-light">Booking ID</div>
            <div class="font-bold text-black">
              {{ Booking_ID(b) || '—' }}
            </div>
          </div>

          <div>
            <div class="text-xs text-gray-light">Agent Ref</div>
            <div class="font-bold text-black">
              {{ Agent_Reference(b) || '—' }}
            </div>
          </div>

          <div>
            <div class="text-xs text-gray-light">Consultant</div>
            <div class="font-bold text-black">
              {{ Get_Consultant(b) || '—' }}
            </div>
          </div>

          <div>
            <div class="text-xs text-gray-light">Trip</div>
            <div class="font-bold text-black truncate" :title="Trip_Name(b)">
              {{ Trip_Name(b) || '—' }}
            </div>
          </div>

          <div>
            <div class="text-xs text-gray-light">Status</div>
            <div class="font-bold text-black">
              {{ Booking_Status(b) || '—' }}
            </div>
          </div>
        </div>

        <div class="flex justify-start pt-2">
          <button
            class="button btn-primary btn-sm rounded-md"
            :disabled="loadingIndex === index"
            @click="Booking_Details(b, index)"
          >
            <span
              v-if="loadingIndex === index"
              class="loading loading-spinner loading-xs mr-2"
            ></span>
            View details
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="(Sorted_Bookings?.length ?? 0) === 0"
      class="text-sm text-gray-light text-center py-8"
    >
      No bookings to display.
    </div>
  </div>
</template>

<script lang="ts" src="./booking_cards.ts"></script>
